export enum SubItemTypeEnum {
    gauge = 'gauge',
    commercial = 'commercial',
    picto = 'picto',
}
